import { Fade } from "@mui/material"
import { LinkOutlined } from "@mui-symbols-material/w300"
import React from "react"

import { InformationMissingAlert } from "@/components/common/Alerts/InformationMissingAlert"
import { Button } from "@/components/common/Button"

interface AddPaymentMethodAlertProps {
  onAddPaymentMethod: () => void
}

const AddPaymentMethodAlert: React.FC<AddPaymentMethodAlertProps> = ({ onAddPaymentMethod }) => {
  return (
    <Fade in unmountOnExit timeout={500}>
      <InformationMissingAlert
        title='Add company payment method type details and/or banking information'
        titleClassName='text-ml'
        action={
          <Button
            color='inherit'
            size='small'
            appearance='outlined'
            className='text-primary'
            startIcon={<LinkOutlined />}
            onClick={onAddPaymentMethod}
          >
            Add Payment Type
          </Button>
        }
      />
    </Fade>
  )
}

export default AddPaymentMethodAlert
